module.exports = __webpack_public_path__ + "img/cszg.32777621.png";